import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

interface FilterStore {
    isExpandedSearch: boolean | null;
    setExpandedSearch: (val: boolean) => void;
}

export const useFilter = create<FilterStore>()(
    devtools(
        immer((set, _) => ({
            isExpandedSearch: null,
            setExpandedSearch: (val: boolean) => set({
                isExpandedSearch: val
            }),
        })),
    ),
);
